import React, { useEffect } from "react";
/* Components */
import SignUpFormGoogle from "../components/form/signUp_Google";
import { useMixPanel } from '../hooks/useMixPanel';
//import { useTranslation } from 'react-i18next';
import { MIX_PANEL_EVENTS } from '../utils/constans';

const GoogleRegister = () => {
  const { sendEvent } = useMixPanel();
  //const { t } = useTranslation();
  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.registerView);
    localStorage.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <div className="login-wrapper">
      <SignUpFormGoogle />
    </div>
  );
};

export default GoogleRegister;
